<a class="metro-card rounded no-pointer" href="javascript: void(0)" (click)="openImage(image)">
    <div class="card-image" [ngStyle]="{ 'background-image': 'url(' + image + ')' }">
      <div class="card-overlay">
        <div class="card-text-top">
          <div class="sub">{{ description }}</div>
          <h2 class="title">{{ city }}</h2>
          <div class="date" *ngIf="date">{{ date }}</div>
        </div>
      </div>
    </div>
</a>

<app-image-viewer 
  [imageUrl]="selectedImage" 
  [show]="viewerOpen" 
  (closeViewer)="viewerOpen = false">
</app-image-viewer>